export const getDate = value => {
  if (!value) {
    return null;
  }
  const result = new Date(value)
  if (isNaN(result.getTime())) {
    return null
  }
  return result
}

export const compareDates = (a, b) => {
  const ta = a ? a.getTime() : 0
  const tb = b ? b.getTime() : 0
  return (ta > tb) - (ta < tb)
}
